import React from 'react';
import { MenuItem } from '@mui/material';
import { useFetch } from 'use-http';
import { Browser } from '@capacitor/browser';
import { useAppState } from '../providers/app-state/app-state-provider';
import appStrings from '../common/app_strings';

const {
  hamburgerMenu: {
    grow,
  },
} = appStrings;

const GrowMenuItem = () => {
  const url = import.meta.env.VITE_GROW_URL;
  const {
    platform: { isNativePlatform },
  } = useAppState();
  const { get: getTempToken } = useFetch('/users/crossdomain');

  const openInBrowser = async () => {
    try {
      let browserUrl = url;
      if (isNativePlatform) {
        const tokenResponse = await getTempToken();
        const params = tokenResponse.temporary_token;
        browserUrl = `${url}/login?temp=${encodeURIComponent(params)}`;
      }
      await Browser.open({ url: browserUrl });
    } catch (e) {
      // Optionally log or handle error here
    }
  };

  return (
    <MenuItem disableRipple onClick={openInBrowser}>
      {grow}
    </MenuItem>
  );
};

export { GrowMenuItem };
